var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v(" "+_vm._s(_vm.labels.confirm)+" ")]),_c('el-button',{on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.labels.cancel)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }